import styled from "styled-components";

export const ConfirmedOrdersAlertContainer = styled.div<{ hasMarginLeft: boolean }>`
  min-width: fit-content;
  max-width: 100%;
  height: auto;
  min-height: 40px;

  margin-left: ${(props) => (props.hasMarginLeft ? "0" : "24px")};

  border-radius: 4px;

  padding: 10px 16px;

  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;

  background-color: #F9B609;
  color: #0F1111;

  cursor: pointer;
  user-select: none;
  
  display: flex;
  align-items: center;

  transition: all 0.2s ease-in-out;
  
  margin-top: 0.8rem;

  &:hover {
    background-color: #E0A508;
  }

  strong {
    font-family: 'Lato', sans-serif;
    font-weight: 700;
    font-size: 14px;
    line-height: 100%;
  }

  .alert-text {
    flex: 1;
  }
`;


